import { Affix, Layout } from 'antd';
import AppFooter from './AppFooter';
import AppHeader from './AppHeader';
import Authed from './_authed';
import ContextLoadingChecker from './ContextLoadingChecker';
import { HomeIcon } from '../components/images/NavIcons';
const currentSection = {
  icon: <HomeIcon />,
  name: 'Home'
};
export default (({
  children
}) => <Authed>
    <Affix>
      <AppHeader currentSection={currentSection} />
    </Affix>
    <ContextLoadingChecker>
      <Layout.Content style={{
      margin: 20,
      marginTop: 0,
      overflow: 'initial'
    }} children={children} />
    </ContextLoadingChecker>
    <AppFooter />
  </Authed>);